var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4082 9.41269L10.5782 0.582685C10.2082 0.212685 9.69817 0.00268555 9.16817 0.00268555H1.99817C0.898169 0.00268555 -0.00183105 0.902686 -0.00183105 2.00269V9.17269C-0.00183105 9.70269 0.208169 10.2127 0.588169 10.5827L9.41817 19.4127C10.1982 20.1927 11.4682 20.1927 12.2482 19.4127L19.4182 12.2427C20.1982 11.4627 20.1982 10.2027 19.4082 9.41269ZM10.8282 18.0027L1.99817 9.17269V2.00269H9.16817L17.9982 10.8327L10.8282 18.0027Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49817 6.00269C5.3266 6.00269 5.99817 5.33111 5.99817 4.50269C5.99817 3.67426 5.3266 3.00269 4.49817 3.00269C3.66974 3.00269 2.99817 3.67426 2.99817 4.50269C2.99817 5.33111 3.66974 6.00269 4.49817 6.00269Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSales);
export default __webpack_public_path__ + "static/media/IconSales.451c3100666584335022801688491c66.svg";
export { ForwardRef as ReactComponent };